import React, { useEffect, useState } from "react";
import "./livePrice.scss";
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip
} from "recharts";
import ChartCard from "../../components/dashboard/Crypto/ChartCard";


function LivePrice(props) {
  const [myData, setMyData] = useState([]);
  const [status, setStatus] = useState();
  useEffect(() => {

    (props.data[props.data.length - 1] - props.data[props.data.length - 2]) > 0 ? setStatus('up') : setStatus('down');
    props.data.map(item => setMyData((myData) =>
      [...myData, { price: item - 90 * Math.min(...props.data) / 100 }]))

  }, [])
  const CustomTooltip = ({ active, label }) => {
    if (active) {
      return (
        <div className="my-tooltip">
          <p>{props.data[label]} </p>
        </div>
      );
    }

    return null;
  };

  return (
    <div className='tmex-live-price'>
      <div className='right-side'>
        <div className='info'>
          <div className='icon'>
            <img src={props.image} alt='coin' />
          </div>
          <div className='name'>
            <h3>{props.id}</h3>
            <h4>{props.name}</h4>
          </div>
        </div>
        <div
            onClick={() => window.location.replace(localStorage.getItem('phone') ? '/userpanel/order' : '/authorization/')}
            className='button d-flex d-lg-none'>
          <i className="fas fa-shopping-cart" />
          <p>خرید</p>
        </div>
      </div>
      <span />
      <div className='left-side'>
        <div className="chart">
          <ChartCard
            children={
              <ResponsiveContainer height={35} className="chart-header">
                <AreaChart
                  data={myData}
                  margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                >
                  <Tooltip content={<CustomTooltip />} />
                  <defs>

                  </defs>
                  <Area
                    dataKey="price"
                    type="monotone"
                    strokeWidth={3}
                    stackId="2"
                    stroke={status === 'up' ? '#1fcb81' : '#ff4e82'}
                    fill={status === 'up' ? '#e0fff1' : '#ffcfdd'}
                    fillOpacity={1}
                  />
                </AreaChart>
              </ResponsiveContainer>
            }
          />
        </div>
        <div className="price down">
          <p>{props.price} دلار </p>
          <div className='change'>
            <i className={`${status} far fa-arrow-alt-circle-${status}`} />
            <p className={status}>{parseFloat(props.changePercent)} % ({props.changeAmout})</p>
          </div>
        </div>
      </div>
      <div
          onClick={() => window.location.replace(localStorage.getItem('phone') ? '/userpanel/order' : '/authorization/')}
          className='button d-none d-lg-flex'>
        <i className="fas fa-shopping-cart" />
        <p>خرید</p>
      </div>
    </div>

  );
}

export default LivePrice;
